/**
 * Game elements - data from alchemy_tree (6).html
 * 37 elements (6 levels)
 */

import { Element } from '../types/game';
export const ELEMENTS: Record<string, Element> = {
    // Level 1: Basic (4)
    fire: { n: "Fire", i: "🔥", l: 1 },
    water: { n: "Water", i: "💧", l: 1 },
    earth: { n: "Earth", i: "🌍", l: 1 },
    air: { n: "Air", i: "💨", l: 1 },

    // Level 2: Simple combinations (8)
    steam: { n: "Steam", i: "♨️", l: 2 },
    lava: { n: "Lava", i: "🌋", l: 2 },
    mud: { n: "Mud", i: "🟤", l: 2 },
    dust: { n: "Dust", i: "🌫️", l: 2 },
    energy: { n: "Energy", i: "⚡", l: 2 },
    stone: { n: "Stone", i: "🪨", l: 2 },
    wind: { n: "Wind", i: "🌬️", l: 2 },
    coal: { n: "Coal", i: "⚫", l: 2 },

    // Level 3: Complex elements (8)
    cloud: { n: "Cloud", i: "☁️", l: 3 },
    obsidian: { n: "Obsidian", i: "⬛", l: 3 },
    sand: { n: "Sand", i: "🏖️", l: 3 },
    metal: { n: "Metal", i: "⚙️", l: 3 },
    lightning: { n: "Lightning", i: "🌩️", l: 3 },
    plant: { n: "Plant", i: "🌱", l: 3 },
    crystal: { n: "Crystal", i: "💎", l: 3 },
    ice: { n: "Ice", i: "❄️", l: 3 },

    // Level 4: Rare elements (6)
    sun: { n: "Sun", i: "☀️", l: 4 },
    moon: { n: "Moon", i: "🌙", l: 4 },
    tree: { n: "Tree", i: "🌳", l: 4 },
    glass: { n: "Glass", i: "🔮", l: 4 },
    storm: { n: "Storm", i: "🌪️", l: 4 },
    sword: { n: "Sword", i: "⚔️", l: 4 },

    // Level 5: Legendary (3)
    gold: { n: "Gold", i: "🥇", l: 5 },
    life: { n: "Life", i: "🌿", l: 5 },
    magic: { n: "Magic", i: "✨", l: 5 },

    // Level 6: Philosopher's Stone (1)
    philosopher_stone: { n: "Philosopher's Stone", i: "🜛", l: 6 }
};

// Helper functions for working with elements

/**
 * Get element by key
 */
export function getElement(key: string): Element | undefined {
  return ELEMENTS[key];
}

/**
 * Get all elements of a specific level
 */
export function getElementsByLevel(level: number): Array<[string, Element]> {
  return Object.entries(ELEMENTS).filter(([_, el]) => el.l === level);
}

/**
 * Get base elements (level 1)
 */
export function getBaseElements(): Array<[string, Element]> {
  return getElementsByLevel(1);
}

/**
 * Check if element is basic
 */
export function isBaseElement(key: string): boolean {
  const element = ELEMENTS[key];
  return element?.l === 1;
}

/**
 * Check if element is Philosopher's Stone
 */
export function isPhilosopherStone(key: string): boolean {
  return key === 'philosopher_stone';
}
